import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WillkommenImBodyconcept from "./sections/WillkommenImBodyconcept";
import TheVectrPhilosophy from "./sections/TheVectrPhilosophy";
import PilaresAcademicos from "./sections/PilaresAcademicos";
import OurEliteServices from "./sections/OurEliteServices";
import WordFromTheField from "./sections/WordFromTheField";
import BeginYourExperience from "./sections/BeginYourExperience";
import Contatti from "./sections/Contatti";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WillkommenImBodyconcept />
      <TheVectrPhilosophy />
      <PilaresAcademicos />
      <OurEliteServices />
      <WordFromTheField />
      <BeginYourExperience />
      <Contatti />
      <Footer />
    </div>;
}